/**
 * Developer portal session token.
 *
 * This key is intentionally separate from Admin-Token: portal members are not
 * IoT business users and must not inherit the internal admin session.
 */
const PortalTokenKey = 'Developer-Portal-Token';

export const getPortalToken = () => localStorage.getItem(PortalTokenKey) || '';
export const setPortalToken = (token: string) => localStorage.setItem(PortalTokenKey, token);
export const removePortalToken = () => localStorage.removeItem(PortalTokenKey);

/** Remove only the old portal credential payload cached by repeat-submit protection. */
export const clearLegacyPortalCredentialCache = () => {
  try {
    const cached = JSON.parse(sessionStorage.getItem('sessionObj') || 'null');
    if (cached && /^\/open\/portal\/(auth\/(login|bootstrap)|admin\/users(?:\/[^/]+\/reset-password)?)$/.test(cached.url)) {
      sessionStorage.removeItem('sessionObj');
    }
  } catch {
    // Browser storage can be unavailable; do not interrupt authentication.
  }
};
